import apiClient from '../../../shared/api/client';

export const getAuditLogs = async (params) => {
  const { data } = await apiClient.get('/audit-logs', { params });
  return data;
};

export const getAuditLogActions = async () => {
  const { data } = await apiClient.get('/audit-logs/actions');
  return data;
};
